// import { baseURL } from '../../config/constant';
import Utils from '../utils';

const getHealthCheck = async (id) => {
  try {
    const apiOptions = {
      // endpoint: `https://foodics.chefadmin.com/api/foodics/health-data?brand_id=${id}`, // Live
      endpoint: `https://foodics.sadaynaal.com/api/foodics/health-data?brand_id=${id}`,
      headers: {
        Authorization: `Bearer ${Utils.getCurrentToken()}`,
      },
      method: 'GET',
    };
    const apiResponse = await Utils.CallApi(apiOptions);
    return apiResponse.data;
  } catch (error) {
    return error;
  }
};

const HealthCheckActions = {
  getHealthCheck,
};

export default HealthCheckActions;
